import { render, staticRenderFns } from "./Producttable.vue?vue&type=template&id=efbc23fa"
import script from "./Producttable.vue?vue&type=script&lang=js"
export * from "./Producttable.vue?vue&type=script&lang=js"
import style0 from "./Producttable.vue?vue&type=style&index=0&id=efbc23fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports